import { useTranslation } from 'react-i18next';
import { MdLogout } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';

import { ROUTES } from '@/AppRoutes';
import studentProfileImage from '@/Assets/Images/student-profile.svg?url';
import { useButtonDialogBox } from '@/hooks/useButtonDialogBox';
import useAccessLocation from '@/hooks/useGetAccessLocation';
import useStore from '@/store';

function LogoutStudentProfile({
  showStudentProfile = true,
  showLogout = true,
}: {
  showStudentProfile: boolean;
  showLogout: boolean;
}) {
  const { logoutStudent, currentStudent } = useStore();
  const navigate = useNavigate();
  const { t } = useTranslation(['translation', 'studentLogin', 'studentProfile']);
  const { showButtonDialogBox, closeDialog } = useButtonDialogBox();
  const { accessLocation } = useAccessLocation();
  const onStudentProfileClick = () => {
    navigate(ROUTES.STUDENT_PROFILE);
  };

  const onStudentLogoutClick = () => {
    showButtonDialogBox({
      open: true,
      title: t('studentLogin:logoutWarning'),
      leftButtonText: t('studentLogin:cancelButton'),
      rightButtonText: t('studentProfile:logout'),
      onRightButtonClick: () => {
        navigate(
          accessLocation === 'home' ? `${ROUTES.AT_HOME}?step=profile` : ROUTES.STUDENT_LOGIN,
        );
        logoutStudent({ source: 'ui' });
      },
      onLeftButtonClick: closeDialog,
      variant: 'blue',
      showCloseButton: false,
    });
  };

  return (
    <div className="flex h-[3.3125rem] items-center justify-center rounded-2xl bg-transparent">
      {showStudentProfile && (
        <button
          className="mr-3 flex h-full cursor-pointer items-center justify-center gap-2 rounded-[0.625rem] bg-secondary-blue-7 p-2"
          type="button"
          onClick={onStudentProfileClick}
        >
          <div className="flex flex-col items-end justify-start">
            <p className="text-sm font-bold text-neutral-white">{currentStudent?.name}</p>
            <p className="text-sm font-bold text-neutral-white">{`${t(
              'translation:grade',
            )} ${currentStudent?.grade}`}</p>
          </div>
          <img src={studentProfileImage} alt="Student Profile" />
        </button>
      )}
      {showLogout && (
        <button
          className="flex h-[2.75rem] w-[2.75rem] cursor-pointer items-center justify-center rounded-full bg-primary-yellow-3 p-2"
          type="button"
          aria-label="Logout"
          onClick={onStudentLogoutClick}
        >
          <MdLogout style={{ color: '#FFFFFF', fontSize: '1.5rem', marginLeft: '0.25rem' }} />
        </button>
      )}
    </div>
  );
}

export default LogoutStudentProfile;
